import { useDateFormat, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { ButtonVariantTypes } from '@etg/wings';
import { Button, Card, Heading, Stack } from '@etg/wings';
import { variants } from '@eti/components';
import { FormProvider, useForm } from 'react-hook-form';
import {
  DEPARTURE_DATE,
  RETURN_DATE,
  SINGLE_BOUND,
} from '../../../widgets/search-form/constants/formFieldNames';
import type { SearchTripsFormType, TripType } from '../models';
import DatesNew from '../../../widgets/search-form/components/DatesNew';

const changeTripDatesSearchFormWrapperStyles = css`
  display: flex;
  width: 100%;
`;

const buttonStyles = css`
  align-self: end;
  display: flex;
`;

export interface DatesSearchProps {
  handleSearch: (formValues: SearchTripsFormType) => Promise<void>;
  originalTrip: TripType;
}

const DatesSearchForm = ({ handleSearch, originalTrip }: DatesSearchProps) => {
  const { t } = useTranslation();
  const { date } = useDateFormat();
  const methods = useForm<SearchTripsFormType>({
    defaultValues: {
      [SINGLE_BOUND]: {
        [DEPARTURE_DATE]: null,
        [RETURN_DATE]: null,
      },
    },
  });

  return (
    <div className={changeTripDatesSearchFormWrapperStyles} id="changeTrip-search-form">
      <Card>
        <Stack spacing={16}>
          <Heading data-testid="changeTrip-changeDate-title" level={2}>
            {t('ChangeTrip.ChangeDate.Title')}
          </Heading>
          <FormProvider {...methods}>
            <form
              aria-label={t('ScreenReader.SearchForm.FormLabel')}
              onSubmit={methods.handleSubmit(handleSearch)}
            >
              <Stack>
                <DatesNew
                  boundIndex={0}
                  dateFormat={date}
                  departureDateName={`${SINGLE_BOUND}.${DEPARTURE_DATE}`}
                  selectedTripType={originalTrip.type}
                />

                <Button
                  className={buttonStyles}
                  data-testid="changeTrip-changeDate-searchFlights-button"
                  type="submit"
                  variant={variants.PRIMARY as ButtonVariantTypes}
                >
                  {t('Button.Text.Search.Air')}
                </Button>
              </Stack>
            </form>
          </FormProvider>
        </Stack>
      </Card>
    </div>
  );
};

export default DatesSearchForm;
